<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <b>Unit Group</b>
          <!-- <span class="pull-right">#5669626</span> -->
        </h3>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <!-- <Datatables @doDetail="doDetail" @doEdit="doEdit" :action="true" action-data="row_number" :url="'unit-group'" :dtfields="headers">
              <template>
              <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" data-action="doDetail" class="btn btn-success"><i class="mdi mdi-magnify"></i></button>
                <button type="button" data-action="doEdit" class="btn btn-warning"><i class="mdi mdi-grease-pencil"></i></button>
              </div>
              </template>
            </Datatables> -->
            <Table
              :items="items"
              :filter="filters"
              :header="headers"
              :onAction="get"
              :onDetail="doDetail"
              :onEdit="doEdit"
              :onUser="true"
              @onDelete="doDelete"
              :forbidEdit="forbidUpdate"
              :forbidDetail="forbidRead"
              :forbidDelete="forbidDel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from "@/components/table/table";
import { RotateSquare5 } from "vue-loading-spinner";

export default {
  components: {
    RotateSquare5,
    Table,
  },
  data() {
    return {
      headers: {
        name: {
          label: "Name",
          data: "name",
        },
        // as_label: {
        //   label: "Label",
        //   render: function (data) {
        //     return data ? "Ya" : "Tidak";
        //   },
        // },
      },
    };
  },
  computed: {
    items() {
      return this.$store.state.unitGroup.items.items
        ? this.$store.state.unitGroup.items.items
        : [];
    },
    filters() {
      return this.$store.state.unitGroup.items.filters
        ? this.$store.state.unitGroup.items.filters
        : {};
    },
    state() {
      return this.$store.state.unitGroup;
    },
    forbidUpdate() {
      if (this.$store.state.profile.permissions.user) {
        return !this.$store.state.profile.permissions.user.update;
      }
    },
    forbidRead() {
      if (this.$store.state.profile.permissions.user) {
        return !this.$store.state.profile.permissions.user.read;
      }
    },
    forbidDel() {
      if (this.$store.state.profile.permissions.user) {
        return !this.$store.state.profile.permissions.user.delete;
      }
    },
  },
  mounted() {
    const state = {
      loaded: false,
      isAdd: false,
      isEdit: false,
      isDetail: false,
      items: [],
    };
    this.$store.commit("unitGroup/STATE", state);
    this.get(state);
  },
  methods: {
    get(val) {
      this.$store.dispatch("unitGroup/getUnitGroup", val);
    },
    doDetail(val) {
      this.$store.dispatch("unitGroup/onDetail", val);
    },
    doEdit(val) {
      this.$store.dispatch("unitGroup/onEdit", val);
    },
    doDelete(val) {
      this.$store.dispatch("unitGroup/submitDelete", val);
    },
  },
};
</script>
